// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1IkH2","content":"styles_content__305Wo","selectAll":"styles_selectAll__3uhCR"};